import { motion } from "framer-motion";

const ScrollingText = () => {
  const text =
    "  Web Development  •  Website Design  •  Creating Portfolios  •  ATS Friendly Resume Creation  •  MERN Stack Courses Available  •  ";

  // Create an array by repeating text
  const repeatedText = Array.from({ length: 50 }, () => text);

  return (
    <div className="pointer-events-none bg-primary overflow-hidden text-2xxl flex items-center justify-center w-full whitespace-nowrap h-20">
      <motion.div
        className="inline-flex"
        animate={{
          x: ["0%", "-100%"],
        }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration: 1500, 
            ease: "linear",
          },
        }}
      >
        {repeatedText.map((t, index) => (
          <span
            key={index}
            className={`text-title3 font-semibold bg-black py-4 ${
              index % 2 === 0 ? "text-yellow-400" : "text-white"
            }`}
          >
            {t}
          </span>
        ))}
      </motion.div>
    </div>
  );
};

export default ScrollingText;
